// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__O6B7P","title":"ClientInsurance_title__BjI2_","itemText":"ClientInsurance_itemText__3u3wa"};